import { gql } from "gql";

export const TREATMENT_OVERVIEWS_QUERY = gql(`
  query TreatmentOverviews($accessCode: String!, $clientDateTime: LocalDateTime) {
    treatmentOverviews(accessCode: $accessCode, clientDateTime: $clientDateTime) {
      programInfo {
        headerTitleKey
      }
      treatments {
        __typename
        formattedProgramName
        treatmentName
        treatmentCode
        productImageUrl
        productIconUrl
        productBackgroundColor
        deeplink
        actionLinks {
          linkKey
          label
          url
          iconUrl
        }
        chatWithDoctorDeeplink
        isMedicationLogSupported
        ... on RxTreatmentOverview {
          status {
            __typename
            ... on TreatmentOverviewStatusIntakeIncomplete {
              ctaDeeplink
              deadlineDate
            }
            ... on TreatmentOverviewStatusUpdate {
              ctaDeeplink
            }
            ... on TreatmentOverviewStatusRefills {
              nextRefillDate
            }
            ... on TreatmentOverviewStatusInReview {
              ctaDeeplink
            }
            ... on TreatmentOverviewStatusShipped {
              shippedDate
              trackingUrl
              storageInstruction
            }
            ... on TreatmentOverviewStatusDelivered {
              storageInstruction
            }
          }
          latestDoseTaken {
            unitsTaken
            takenOn
            isSmartDose
            dosage {
              amount
              unit
            }
          }
          initialDose {
            doseSyringeUnits
            dosage {
              amount
              unit
            }
          }
          concentration {
            amount
            unit
          }
          schedule {
            cadence
            frequency
          }
          scheduledDayOfWeek
          isRefill
          clinicianDetail {
            name
            photoUrl
          }
        }
        ... on OTCTreatmentOverview {
          status {
            __typename
            ... on TreatmentOverviewStatusShipped {
              shippedDate
              trackingUrl
            }
            ... on TreatmentOverviewStatusReplacementShipped {
              shippedDate
              trackingUrl
            }
            ... on TreatmentOverviewStatusRefills {
              nextRefillDate
            }
          }
          purchaseDate
        }
        ... on LabTreatmentOverview {
          status {
            __typename
            ... on TreatmentOverviewStatusShipped {
              shippedDate
              trackingUrl
            }
            ... on TreatmentOverviewStatusReplacementShipped {
              shippedDate
              trackingUrl
            }
            ... on TreatmentOverviewStatusCompletedKitShipped {
              trackingUrl
            }
            ... on TreatmentOverviewStatusDelivered {
              deliveredDate
            }
            ... on TreatmentOverviewStatusResultsAvailable {
              resultsUrl
              resultsDate
            }
          }
          previousDetails {
            resultsDate
            resultsUrl
          }
        }
      }
    }
  }
`);

export const MARKETPLACE_ADS_QUERY = gql(`
  query MarketplaceAds($accessCode: String, $placementGroupName: String!) {
    placementGroupAds(accessCode: $accessCode, placementGroupName: $placementGroupName) {
      placementGroupContent {
        __typename
        ... on MarketplaceContent {
          headerImageUrl
          disclaimers
        }
      }
      placements {
        placementName
        placementContent {
          __typename
          ... on CarouselSectionContent {
            title
            description
            disclaimers
            cardVariant
          }
        }
        ads {
          adName
          offerName
          offerType
          targetUrl
          offerEligibilityState
          recommendationContext {
            recommendationId
            itemId
            recommendationSurface
            positionViewed
            eventLocalDatetime
            origin
          }
          content {
            __typename
            ... on AdCardContent {
              title
              description
              backgroundImageUrl
              productImageUrl
              ctaText
              disclaimer
              pill {
                text
                imageUrl
              }
            }
          }
        }
      }
    }
  }
`);

export const TRACK_AD_INTERACTIONS_MUTATION = gql(`
  mutation TrackAdInteractions($accessCode: String, $interactions: [AdInteractionInput!]!) {
    trackAdInteractions(accessCode: $accessCode, interactions: $interactions) {
      success
    }
  }
`);
